import { parsePhoneNumber } from 'libphonenumber-js'
import { Copy } from 'lucide-react'

import CopyButtonWithAnimation from './CopyButtonWithAnimation'

interface CopyFieldRowProps {
  isPhoneNumber?: boolean
  label: string
  omitIfUndefined?: boolean
  value?: string | null
}

export function CopyFieldRow ({
  isPhoneNumber = false,
  label,
  omitIfUndefined = false,
  value,
}: CopyFieldRowProps) {
  if (omitIfUndefined && value === undefined) {
    return null
  }

  if (!value) {
    return (
      <div className='px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0'>
        <dt className='text-sm font-medium leading-6 text-gray-900'>{label}</dt>
        <dd className='mt-1 text-sm leading-6 text-gray-400 sm:col-span-2 sm:mt-0'>
          (none)
        </dd>
      </div>
    )
  }

  const displayValue =
    isPhoneNumber && value
      ? parsePhoneNumber(value, 'US').formatNational()
      : value

  const copyValue =
    isPhoneNumber && value
      ? parsePhoneNumber(value, 'US').formatNational().replace(/[^\d]/g, '')
      : value

  return (
    <div className='px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0'>
      <dt className='text-sm font-medium leading-6 text-gray-900'>{label}</dt>
      <dd className='mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 flex items-center'>
        <span>
          {isPhoneNumber && value
            ? (
              <a href={`tel:${value}`}>{displayValue}</a>
              )
            : (
                displayValue
              )}
        </span>
        <CopyButtonWithAnimation content={copyValue}>
          <Copy size={16} strokeWidth={1} />
        </CopyButtonWithAnimation>
      </dd>
    </div>
  )
}
